import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import { task, timeout } from 'ember-concurrency';
import Ember from 'ember';
import DS from 'ember-data';
import config from 'cio/config/environment';

export default class ObjectsController extends Controller {
  @service store!: DS.Store;

  pollForObjectTypes = task({ drop: true }, async () => {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      let objectTypes = (await this.store.findAll('object-type')).toArray();
      if (objectTypes.length > 0 || Ember.testing) {
        break;
      }
      await timeout(config.APP.pollingDelay);
    }
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    objects: ObjectsController;
  }
}
